import {
  COMPONENT_VALUE_TYPES as types,
  COMPONENT_COLOR_THEMES,
} from 'shared/constants';

const propsSchema = [
  {
    key: 'colorTheme',
    label: 'Color Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES
  },
  {
    key: 'image',
    label: 'Image',
    type: types.OBJECT,
    children: [
      {
        type: types.S3_ASSET_URL,
        key: 'src',
        label: 'Image source',
        tooltip: 'Image can be cropped to support mobile, tablet, and desktop viewports',
        options: {
          cropEnabled: true,
          croppers: [
            {
              name: 'mobile',
              description: 'Mobile Screen (0px-600px)',
              aspectRatio: '1 / 1',
            },
            {
              name: 'tablet',
              description: 'Tablet Screen (601px-900px)',
              aspectRatio: '4 / 3',
            },
            {
              name: 'desktop',
              description: 'Desktop Screen (901px-1200+px)',
              aspectRatio: '16 / 9',
            },
          ],
        },
      },
      {
        key: 'alt',
        label: 'Image description',
        tooltip: 'User-friendly description of the image ("alt" tag)',
        type: types.TEXT,
      },
    ]
  },
  {
    key: 'effects',
    label: 'Effects',
    type: types.OBJECT,
    children: [
      {
        type: types.BOOLEAN,
        key: 'zoomOnScroll',
        label: 'Zoom on Scroll (desktop/tablet only)',
        tooltip: 'Image zooms out as user scrolls',
      }
    ]
  },
];

const defaultProps = {
  colorTheme: COMPONENT_COLOR_THEMES[0],
  image: {
    src: 'https://genesis-cdn.ff.com/our_company/01_people/our-people-01.jpg',
    alt: 'Our people'
  },
  effects: {
    zoomOnScroll: false
  }
};

export default {
  title: 'Animated Image',
  id: 'AnimatedImage',
  propsSchema,
  defaultProps
};
